<template>
          <NavBarWeb :showMerchantLogin="true" />
  <div class="" style="text-align: left">

    <div class="company-summary-container" style="background-color: #F3EEE7;">
      <div class="container-sm">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="summary-title">{{ $t("m.UNLEASH_SHOPPING") }}</div>
            <div class="summary-description pt-3">{{ $t("m.FROM_STARTUPS") }}</div>
            <div class="pt-3 pb-5">
              <div class="d-flex flex-raw align-items-center">
                <div class="summary-item">2,500+ </div>
                <div class="summary-item-description">{{ $t("m.SRI_LANKAN_MERCHANTS") }}</div>
              </div>
              <div class="d-flex flex-raw align-items-center">
                <div class="summary-item">500,000+</div>
                <div class="summary-item-description">{{ $t("m.SHOPPERS") }}</div>
              </div>
              <div class="d-flex flex-raw align-items-center">
                <div class="summary-item">15+</div>
                <div class="summary-item-description">{{ $t("m.GLOBAL_BRANDS") }}</div>
              </div>
            </div>
                <div class="round-corner-button-container">
                  <a :href="merchantSignUpUrl" target="_blank">
                    <div class="round-corner-button">
                      {{ $t("m.GET_STARTED_KOKO_MERCHANT") }}
                    </div>
                  </a>
                </div>
              </div>
              <div class="d-flex col-md-6 col-sm-12">
            <img src="@/assets/images/company_summary_banner.webp"
              class="company-summary-image" />
          </div>
        </div>
      </div>
    </div>

    <div class="sectionKoko">
      <div class="container">
        <div class="sectionHead">
          {{ $t("m.header7") }}
        </div>
        <div class="sectionBody">{{ $t("m.header7_a") }}</div>
        <div class="row mt-3" style="text-align: center">
          <div class="col-lg-2 col-sm-6 col-xs-12 partner-image-container" >
            <img src="@/assets/images/abans.webp" alt="abans" class="partner-image">
          </div>
          <div class="col-lg-2 col-sm-6 col-xs-12 partner-image-container">
            <img padding="30px;" src="@/assets/images/suppliment-factory.png" alt="suppliment-factory" class="partner-image">
          </div>
          <div class="col-lg-2 col-sm-6 col-xs-12 partner-image-container">
            <img src="@/assets/images/nolimit.png" alt="nolimit" class="partner-image">
          </div>
          <div class="col-lg-2 col-sm-6 col-xs-12 partner-image-container">
            <img src="@/assets/images/carnage.webp" alt="carnage" class="partner-image">
          </div>
          <div class="col-lg-2 col-sm-6 col-xs-12 partner-image-container">
            <img src="@/assets/images/mimosa.png" alt="mimosa" class="partner-image">
          </div>
          <div class="col-lg-2 col-sm-6 col-xs-12 partner-image-container">
            <img src="@/assets/images/fashionbug.png" alt="fashionbug" class="partner-image">
          </div>

        </div>
      </div>
    </div>

    <div class="sectionKoko" style="background-color: #F1FBFF">
      <div class="container">
        <div class="container " style=" max-width: 800px;">
          <div class="row">
            <div class="col-sm-12 col-lg-6" style="text-align: center">
              <img class="mt-4" src="../assets/images/portraitPhone.webp" alt=“portrait-phone” style="width: 80%; max-width: 350px;">
            </div>
            <div class="col-sm-12 col-lg-6">
              <div class="sectionHead mt-3">{{ $t("m.header3") }}</div>
              <div class="sectionBody">{{ $t("m.header3_a") }}
              </div>

              <table>
                <tr>
                  <td width="30">
                    1
                  </td>
                  <td>
                    <div class="stepHead">{{ $t("m.header3_title1") }}</div>
                    <div class="stepBody">{{ $t("m.header3_title1_a") }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width="30">
                    2
                  </td>
                  <td>
                    <div class="stepHead">{{ $t("m.header3_title2") }}</div>
                    <div class="stepBody">{{ $t("m.header3_title2_a") }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width="30">
                    3
                  </td>
                  <td>
                    <div class="stepHead">{{ $t("m.header3_title3") }}</div>
                    <div class="stepBody">{{ $t("m.header3_title3_a") }}</div>
                  </td>
                </tr>
                <tr>
                  <td width="30">
                    4
                  </td>
                  <td>
                    <div class="stepHead">{{ $t("m.header3_title4") }}</div>
                    <div class="stepBody">{{ $t("m.header3_title4_a") }}
                    </div>
                  </td>
                </tr>
              </table>

              <a :href="merchantSignUpUrl" target="_blank">
                <div class="btn btn-primary kokoWebButtons">
                  <span>{{ $t("buttons.getStarted")}}</span>
                </div>
              </a>

            </div>
          </div>
        </div>
        
      </div>
    </div>
    
    <div class="sectionKoko" style="background-color: #FCFCFF">
      <div class="container">

        <div class="row">
          <div class="col-md-12 col-lg-12 col-xl-3"><img src="../assets/images/sportsKoko.webp" alt="sports"></div>
          <div class="col-md-12 col-lg-12 col-xl-9">
            <div class="sectionHead">
              {{ $t("m.header4") }}
            </div>
            <div class="sectionBody">
              {{ $t("m.header4_a") }}
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12 mt-3 text-center">
                <img src="../assets/images/InstantAccess1.png" alt="instant-access"><br/>
                <span class="iconExpHead">{{ $t("m.header4_title1") }}</span><br/>
                <span class="iconExpBody">{{ $t("m.header4_title1_a") }}</span>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 mt-3 text-center">
                <img src="../assets/images/simpInstallments.png" alt="simple-installments"><br/>
                <span class="iconExpHead">{{ $t("m.header4_title2") }}</span><br/>
                <span class="iconExpBody">{{ $t("m.header4_title2_a") }}</span>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 mt-3 text-center">
                <img src="../assets/images/debit.webp" alt="debits"><br/>
                <span class="iconExpHead">{{ $t("m.header4_title3") }}</span><br/>
                <span class="iconExpBody">{{ $t("m.header4_title3_a") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sectionKoko" style="background-color: #EFF1FD">
      <div class="container">

        <div class="sectionHead">
          {{ $t("m.header5") }}
        </div>
        <div class="sectionBody">{{ $t("m.header5_a") }}
        </div>


        <div class="row" style="padding-top: 40px;">
          <div class="col-sm-6 col-lg-4 col-xs-12 mt-3 text-center">
            <div class="maxWidthDefiner3">
              <img src="../assets/images/SellAnywhere_Website1.png" alt="sell-anywhere-website">
              <div class="bigSpecImgHead">
                {{ $t("m.header5_title1") }}
              </div>

              <div class="iconExpBody">
                {{ $t("m.header5_title1_a") }}
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4 col-xs-12 mt-3 text-center">
            <div class="maxWidthDefiner3">
              <img src="../assets/images/SellAnywhere_Store1.png" alt="sell-anywhere-store">
              <div class="bigSpecImgHead">
                {{ $t("m.header5_title2") }}
              </div>

              <div class="iconExpBody">
                {{ $t("m.header5_title2_a") }}
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4 col-xs-12 mt-3 text-center">
            <div class="maxWidthDefiner3">
              <img src="../assets/images/SellAnywhere_Social1.png" alt="sell-anywhere-social">
              <div class="bigSpecImgHead">
                {{ $t("m.header5_title3") }}
              </div>

              <div class="iconExpBody">
                {{ $t("m.header5_title3_a") }}
              </div>
            </div>
          </div>
        </div>
        <br/><br/><br/>
        <div class="sectionHead">
          {{ $t("m.header6") }}
        </div>
        <div class="sectionBody">{{ $t("m.header6_a") }}
        </div>
        <br/>

        <div class="row" style="opacity: 70%">
          <div class="col-sm-6 col-lg-4 col-xs-12 mt-3 text-center"><img src="../assets/images/woocommerce.png" alt="woocommerce" height="30"></div>
          <div class="col-sm-6 col-lg-4 col-xs-12 mt-3 text-center" ><img src="../assets/images/magento.png" alt="magento" height="30"></div>
          <div class="col-sm-6 col-lg-4 col-xs-12 mt-3 text-center"><img src="../assets/images/shopify.png" alt="shopify" height="30"><br/>Coming soon!</div>
        </div>
      </div>
    </div>

   


    <div class="sectionKoko" style="background-color:#F1EAFF;">
      <div class="container">

        <div class="sectionHead">
          {{ $t("m.header8") }}
        </div>
        <div class="mt-5">
            <span class="iconExpHead" data-toggle="collapse" href="#collapseExample1" role="button" aria-expanded="false" aria-controls="collapseExample1">
                <p>
                    {{ $t("m.header8_title1") }}
                </p>
            </span>
          <div class="collapse" id="collapseExample1">
          <span class="iconExpBody">
                <p>
                    {{ $t("m.header8_title1_a") }}
                </p>
            </span>
          </div>
        </div>
        <div class="mt-5">
            <span class="iconExpHead" data-toggle="collapse" href="#collapseExample2" role="button" aria-expanded="false" aria-controls="collapseExample2">
                <p>
                    {{ $t("m.header8_title2") }}
                </p>
            </span>
          <div class="collapse" id="collapseExample2">
          <span class="iconExpBody">
                <p>
                    {{ $t("m.header8_title2_a") }}
</p>
            </span>
          </div>
        </div>
        <div class="mt-5">
            <span class="iconExpHead" data-toggle="collapse" href="#collapseExample3" role="button" aria-expanded="false" aria-controls="collapseExample3">
                <p>
                    {{ $t("m.header8_title3") }}

                </p>
            </span>
          <div class="collapse" id="collapseExample3">
          <span class="iconExpBody">
                <p>
                    {{ $t("m.header8_title3_a") }}
                </p>
            </span>
          </div>

        </div>
        <div class="mt-5">
            <span class="iconExpHead" data-toggle="collapse" href="#collapseExample4" role="button" aria-expanded="false" aria-controls="collapseExample4">
                <p>
                    {{ $t("m.header8_title4") }}
                </p>
            </span>
          <div class="collapse" id="collapseExample4">
          <span class="iconExpBody">
                <p>
                    {{ $t("m.header8_title4_a") }}
                </p>
            </span>
          </div>
        </div>
        <div class="mt-5">
            <span class="iconExpHead" data-toggle="collapse" href="#collapseExample5" role="button" aria-expanded="false" aria-controls="collapseExample5">
                <p>
                    {{ $t("m.header8_title5") }}
                </p>
            </span>
          <div class="collapse" id="collapseExample5">
          <span class="iconExpBody">
                <p>
                    {{ $t("m.header8_title5_a") }}
                </p>
            </span>
          </div>

        </div>


      </div>
    </div>


    <FooterWeb/>

  </div>
</template>

<script>
import NavBarWeb from "@/components/NavBarWeb";
import FooterWeb from "@/components/FooterWeb";

export default {
  name: "Business",
  components: {FooterWeb, NavBarWeb},
  data() {
    return {
      merchantSignUpUrl: process.env.VUE_APP_MERCHANT_SIGNUP_BASE_URL
    };
  },
  created(){
    document.title = "Buy Now Pay Later with Koko";
    window.fwSettings={
      'widget_id':80000005144
    };
    !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()

  },
  methods: {
    scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    }
  }
}





</script>

<style scoped>
.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 56px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;

}


.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2D3A53;
  text-decoration: none;
}


.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  /* line-height: 42px; */

  color: #393939;

}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;

}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */


  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

.bigSpecImgHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  /* line-height: 29px; */

  color: #393939;


}

.zcwf_col_lab{
  color: #393939;
  opacity: 0.8;
}


.maxWidthDefiner {
  /*max-width: 250px;*/
  margin-top: 30px;
}


.maxWidthDefiner3 {
  max-width: 300px;
  margin-top: 30px;
}


.kokoWebButtons {
  background-color: #000000;
  border: 0;
  height: 40px;
  width: 300px;
  font-weight: bold;
}


.company-summary-container {
  margin-top: 4.5rem;
  padding-top: 60px;
}

.company-summary-image {
  max-width: 80%;
}

.round-corner-button-container{
  padding-bottom: 60px;
}

.round-corner-button {
  display: flex;
  background-color: #000000;
  color: #FFFFFF;
  border: 0;
  height: 40px;
  width: 200px;
  border-radius: 12px;
  align-items: center;
  justify-content: center;
}

.summary-title {
  font-family: Raleway;
  font-style: normal;
  font-weight: 800;
  font-size: 40px;
  color: black;

}

.summary-description {
  font-family: Public Sans;
  font-size: 15px;
  font-weight: 400;
  text-align: left;
  color: black;
}

.summary-item {
  font-family: Open Sans;
  font-size: 20px;
  font-weight: 700;
  text-align: left;
  color: black;

}

.summary-item-description {
  padding-left: 0.5rem;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  color: black;

}

.partner-image-container {
  height:95px;
  max-width:100%;
}

.partner-image {
  max-width:100%;
}

</style>